import React from 'react';
import { ReactComponent as ShipperLogo } from '../assets/shipper-logo.svg';

export default function Logo() {
  return (
    <ShipperLogo width={140} height={50} style={{ margin: '20px 0 0 20px' }} />
  );
}
